import React from 'react'
import {UserContextProvider} from '../../context/User'
import {ReservationEventsContextProvider} from '../../context/ReservationEvents'
import {ReservationResourcesContextProvider} from '../../context/ReservationResources'
import {ReservationProvider} from '../../context/Reservation'
import {ReservationConfigurationContextProvider} from '../../context/ReservationConfiguration'
import {StepActionProvider} from '../../context/StepAction'
import SessionCookies from '../../utils/sessionCookies'
import {ReservationGanttContextProvider} from '../../context/ReservationGantt/ReservationGantt'
import {DialogContextProvider} from '../../context/Dialog/Dialog'
import {ReservationCalendarMainProvider} from '../../context/ReservationCalendarMain'
import {CalendarViewContextProvider} from '../../context/CalendarView/CalendarView'
import {ToastMessageContextProvider} from '../../context/ToastMessage/ToastMessage'
import {MuiPickersUtilsProvider} from '@material-ui/pickers'
import {SettingsContextProvider} from '../../context/Settings/Settings'
import {NewCalendarContextProvider} from '../../context/NewCalendar'
import MomentUtils from '@date-io/moment'
function ReservationInitialize({children}) {
  return (
    <SessionCookies>
      <DialogContextProvider>
        <CalendarViewContextProvider>
          <ReservationGanttContextProvider>
            <ReservationConfigurationContextProvider>
              <ReservationResourcesContextProvider>
                <ReservationCalendarMainProvider>
                  <ReservationProvider>
                    <ToastMessageContextProvider>
                      <UserContextProvider>
                        <StepActionProvider>
                          <SettingsContextProvider>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                              <NewCalendarContextProvider>{children}</NewCalendarContextProvider>
                            </MuiPickersUtilsProvider>
                          </SettingsContextProvider>
                        </StepActionProvider>
                      </UserContextProvider>
                    </ToastMessageContextProvider>
                  </ReservationProvider>
                </ReservationCalendarMainProvider>
              </ReservationResourcesContextProvider>
            </ReservationConfigurationContextProvider>
          </ReservationGanttContextProvider>
        </CalendarViewContextProvider>
      </DialogContextProvider>
    </SessionCookies>
  )
}

export default ReservationInitialize
